import { NgModule } from "@angular/core";
import { WysiwygEditorComponent } from "src/app/components/ui/wysiwyg-editor/wysiwyg-editor.component";
import { CommonModule } from "@angular/common";
import { EditorModule } from "@tinymce/tinymce-angular";
import { TinyEditorDirective } from "src/app/components/ui/wysiwyg-editor/tiny-editor.directive";
import { DxHtmlEditorModule } from "devextreme-angular";

@NgModule({
  imports: [CommonModule, EditorModule, DxHtmlEditorModule],
  declarations: [WysiwygEditorComponent, TinyEditorDirective],
  exports: [WysiwygEditorComponent]
})
export class WysiwygEditorModule {}
